import cn from '@/lib/clsxm';

import TabGroup, { Tab, Tabs } from '@/components/@base/tab';

import { READY_SITE_FILTERS } from '@/constant/iterable-items';

export default function Filters({ selectedTab, onTabChange }) {
  return (
    <TabGroup
      onChange={(index) => {
        onTabChange(index);
      }}
    >
      <Tabs className='flex items-center gap-[10px] py-3'>
        {READY_SITE_FILTERS.map((item, index) => (
          <Tab
            key={index}
            className={cn(
              'h-9 cursor-pointer rounded-md bg-[#F7F8F9] px-[22px] py-1 text-[13px] text-[#878F9B] outline-hidden transition duration-300 hover:bg-[#878F9B] hover:text-white',
              selectedTab === index && 'bg-[rgba(254,160,0,0.1)] text-[#FF9606]',
            )}
          >
            {item.title}
          </Tab>
        ))}
      </Tabs>
    </TabGroup>
  );
}
